import { noop } from "@sail/utils";
import { createContext } from "react";
const DEFAULT_KILLED_IDS = [
    new Set(),
    noop
];
export default /*#__PURE__*/ createContext(DEFAULT_KILLED_IDS);

//# sourceMappingURL=KillSwitchContext.js.map